// src/pages/Spot/TradeTabs.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tabs, Tab } from '@mui/material';
import TradeHistory from './TradeHistory';
import OpenOrders from './OpenOrders';
import socket from '../../services/socket';
import { fetchTradeHistory, fetchOpenOrders } from '../../store/Slices/spotTradingSlice';

// Binance-inspired colors
const COLORS = {
  YELLOW: '#F0B90B',
};

const TradeTabs = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const userId = user?._id;
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const handleOrderStatusUpdate = (data) => {
      console.log('Received order status update:', data);
      // إعادة جلب البيانات مع userId الصحيح
      dispatch(fetchTradeHistory(userId));
      dispatch(fetchOpenOrders(userId));
    };

    const handleConnectError = (error) => {
      console.error('Socket.IO connection error:', error);
    };

    socket.on('order_status_update', handleOrderStatusUpdate);
    socket.on('connect_error', handleConnectError);

    return () => {
      socket.off('order_status_update', handleOrderStatusUpdate);
      socket.off('connect_error', handleConnectError);
    };
  }, [dispatch, userId]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          '& .MuiTabs-flexContainer': { justifyContent: 'flex-start' },
          '& .MuiTabs-indicator': { backgroundColor: COLORS.YELLOW },
          '& .MuiTab-root': {
            color: 'text.secondary',
            textTransform: 'none',
            fontWeight: 500,
            '&.Mui-selected': { color: COLORS.YELLOW },
          },
        }}
      >
        <Tab label="Open Orders" />
        <Tab label="Trade History" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tabValue === 1 ? <TradeHistory /> : <OpenOrders /> }
      </Box>
    </Box>
  );
};

export default TradeTabs;
